
import { graphql as gql } from 'react-relay';
const graphql = gql;

export const filterListQuery = graphql`
query filterListQuery($similarity_search: Boolean!, $similarity_seed_id: ID!) {
  viewer {
    node(id: $similarity_seed_id) @include(if: $similarity_search) {
      ... on TrackSearchResult {
        title
        artist {
          name
        }
      }
    }
  }
}
`;

export const similaritySeed = graphql`
  fragment filterList_viewer on Viewer {
    node(id: $similarity_seed_id) @include(if: $similarity_search) {
      ... on TrackSearchResult {
        title
        artist {
          name
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/filterList.ts